import MenuFrame from "../frames/menu_frame";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, PointElement, LineElement } from 'chart.js';
import { useState } from "react";
import { ReportNav } from "./nav";
import { getOptions, getTransData, makeGraph } from "./reports_halper";
import { Box, Grid } from "@mui/material";
import { Bar } from "react-chartjs-2";


function TransReportViewer() {
    const [deskData, setDeskData] = useState(null);
    ChartJS.register(CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title, Tooltip, Legend);

    const initData = async (auth) => {
        if (!auth) return;
        setDeskData(await getTransData());
    }

    const makeGraphTrans = (data) => {
        if (data === null) return [];
        const label = data.map((itm) => itm.month_year);
        const keys = Object.keys(data[0]).filter(key => key !== 'month_year');
        const final_data = keys.map((key) => data.map((itm) => itm[key]));
        return makeGraph(label, final_data, keys);
    }

    return (
        <MenuFrame permission="ORG_REPORT" screen="FIN_REPORT" onInit={initData}>
            <ReportNav active="transaction" />

            <Grid container spacing={2} sx={{ mt: 2, mb: 2 }}>
                <Grid size={{ xs: 12, sm: 12 }}>
                    <Box sx={{ height: 300 }}>
                        <Bar data={makeGraphTrans(deskData?.type ?? null)} options={getOptions("Transaction - Monthly", false, false)} />
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, sm: 12 }}>
                    <Box sx={{ height: 300 }}>
                        <Bar data={makeGraphTrans(deskData?.ref ?? null)} options={getOptions("Transaction Refrance - Monthly", false, false)} />
                    </Box>
                </Grid>
            </Grid>
        </MenuFrame>
    );
}

export default TransReportViewer;
